import React from "react"
import {  NavLink } from "react-router-dom";
import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import dsd from "../classes/clsDSD";

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';
import '../css/home.css';


class Home extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            ModelLoaded: false
        }

        this.dsd = new dsd(this);

    }

    componentDidMount(){

        this.dsd.getModel();
//        this.setState({ModelLoaded:true})

     }


     setLayoutContent(){

        if (this.context.hasLayout){
            
            let Content = {Index:{}};

            this.context.Layout.setLayoutContent(Content)

            localStorage.setItem("dsdContent",JSON.stringify(Content));
            

        }

        return;

    }

    render() {

        

        if (this.state.ModelLoaded){

            this.setLayoutContent();

//            this.model = this.xpd.model;
            return (
                <div className="home-container">
                    <div className="home-hero">
                        <PD.Heading>Digital Service Designer</PD.Heading>
                        <p className="home-subtitle">
                            A collaboration tool for designing, and documenting, digital services.
                        </p>
                        <div className="home-hero-links">
                            <NavLink to="/terms">Terms of Use</NavLink>
                        </div>
                    </div>

                    <div className="home-features">
                        {this.dsd.config.Features.map((feature, index) => (
                            <NavLink exact to={feature.link} className="home-feature-card" key={index}>
                                <h3 className="home-feature-title">{feature.label}</h3>
                                <p className="home-feature-description">{feature.description}</p>
                                <span className="home-feature-arrow">→</span>
                            </NavLink>
                        ))}
                    </div>

                </div>
            )
        }
        if (this.state.isFailed){
            return(
                <PD.ErrorBox>ERROR - Failed</PD.ErrorBox>
            )
        }
        return <div/>

    };
};


export default Home;